
import {
  getPersonalInfoChecklist,
} from '@/api/agreement/index'

// 获取个人信息收集清单
export async function getPersonalInfoChecklistAction ({ commit }, payload) {
  try {
    const { data = {} } = await getPersonalInfoChecklist(payload);
    const { group_list = []} = data;
    commit('setPersonalInfoChecklist', { data: group_list });
    return data;
  } catch (e) {
    console.log(e)
  }
}

export default {
  getPersonalInfoChecklistAction,
}
